import { EventItem } from "src/modules/chat/models";
import { LocalDbCrud } from "./crud";

export class LocalDbEvents extends LocalDbCrud<EventItem> {
  constructor(db: IDBDatabase) {
    super(db, "events");
  }

  async getAllBySession(session_guid: string): Promise<EventItem[]> {
    return (await this.getAll(session_guid, "session_guid")).sort(
      (a, b) => new Date(a.at).getTime() - new Date(b.at).getTime()
    );
  }
}
